import { render, staticRenderFns } from "./DeleteItemIcon.vue?vue&type=template&id=48756942&scoped=true"
import script from "./DeleteItemIcon.vue?vue&type=script&lang=js"
export * from "./DeleteItemIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48756942",
  null
  
)

export default component.exports